import DOMPurify from 'dompurify';
import { GroupJournalSchedulesLayout } from 'components/layouts';
import { useAppQuery } from 'services/reactQuery/useAppQuery';
import StaffHTTPService from 'services/HTTPService/staff/StaffHTTPService';
import { useJournalId } from 'hooks/useJournalId/useJournalId';
import { useJournalDetailsBreadcrumb } from 'pages/app/staff/journal/journalDetails/hooks';
import { DailyScheduleCard, DailyScheduleEntriesList } from 'components/molecules';

export const GroupJournalDailySchedulePage = () => {
    const { journalId } = useJournalId();

    useJournalDetailsBreadcrumb({
        journalId,
        journalType: 'GROUP',
    });

    const {
        data: dailyScheduleData,
        isInitialLoading: isDailyAttendanceDataInitialLoading,
        isRefetching: isDailyAttendanceDataRefetching,
        isError: isDailyScheduleDataError,
    } = useAppQuery('DAILY_SCHEDULE', [journalId], () =>
        StaffHTTPService.schedules.dailySchedule.getDailySchedule(journalId),
    );

    const scheduleDescription = dailyScheduleData?.description
        ? DOMPurify.sanitize(dailyScheduleData?.description)
        : '';

    return (
        <GroupJournalSchedulesLayout
            scheduleType="DAILY"
            isDataInitialLoading={isDailyAttendanceDataInitialLoading}
            isDataRefetching={isDailyAttendanceDataRefetching}
            isError={isDailyScheduleDataError}
            isEmpty={!dailyScheduleData?.description}
        >
            <DailyScheduleCard description={scheduleDescription} />
            {dailyScheduleData?.entries && (
                <DailyScheduleEntriesList entries={dailyScheduleData.entries} />
            )}
        </GroupJournalSchedulesLayout>
    );
};
